import styled from 'styled-components'

export default styled.div`
  font-size: 14px;
  font-family: Helvetica;
  line-height: 20px;
  text-align: left;
  letter-spacing: -0.36px;
`



// WEBPACK FOOTER //
// ./src/styles/PICSModal.js